import { SidebarRelatedProps } from '@/components/_blog-updates/SidebarRelated';
import { CraftSidebarRelatedData } from './CraftSidebarRelated.types';

export const mapBlockToSidebarRelatedProps = (
  block: CraftSidebarRelatedData,
): SidebarRelatedProps => {
  const articles = (block.sidebarRelatedArticles ?? []).map((article) => ({
    title: article.title ?? '',
    href: article.url,
  }));

  return {
    title: block.sidebarRelatedTitle ?? '',
    articles,
  };
};
